export default "__VITE_ASSET__c697bc4a__"